// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__jKQgE","choiceBoxes":"toolbarselects_choiceBoxes__3j0n-","simpleField":"toolbarselects_simpleField__3lNtR"};